import { useState } from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { collectionApis } from '../../../apis/collectionApis';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';

const ReloadCollectionButton = ({ name, onRefresh }) => {
  const { projectId, instanceId } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleReload = async () => {
    setLoading(true);
    try {
      await collectionApis.reloadCollection(projectId, instanceId, name);
      showToast(
        TOAST_TYPE.SUCCESS,
        t('reloadSuccess', { ns: 'notifications' })
      );
    } catch (error) {
      showToast(TOAST_TYPE.ERROR, t('reloadError', { ns: 'notifications' }));
    } finally {
      onRefresh();
      setLoading(false);
    }
  };

  return (
    <Tooltip title={t('collectionReload', { ns: 'instance' })} arrow>
      <IconButton
        aria-label="reload"
        onClick={handleReload}
        size="large"
        loading={loading}
      >
        <RefreshIcon />
      </IconButton>
    </Tooltip>
  );
};

ReloadCollectionButton.propTypes = {
  name: PropTypes.string.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default ReloadCollectionButton;
